import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { PublicContentSection } from '../../../../../../api/src/content-section/content-section.entity';

export interface ContentSectionState extends EntityState<PublicContentSection> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({
	name: 'content-section'
})
export class ContentSectionStore extends EntityStore<ContentSectionState> {
	constructor() {
		super();
	}
}
